// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Italicize = function Italicize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 2.188c0-.52.418-.938.938-.938h8.124c.52 0 .938.418.938.938 0 .519-.418.937-.937.937h-2.684l-5.727 13.75h3.41c.52 0 .938.418.938.938 0 .519-.418.937-.937.937H3.437a.935.935 0 0 1-.937-.937c0-.52.418-.938.938-.938H6.12l5.727-13.75h-3.41a.935.935 0 0 1-.938-.937"
  }));
};
